import * as yup from "yup";
import { Form } from "@/components/organisms/Form";
import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { showAlert } from "@/components/containers/Alert";
import { useMutation } from "@tanstack/react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import { TextControl } from "@/components/containers/Controls/TextControl";
import { BaseResponse } from "@/common/types/baseRespones";
import { FormInputBox } from "@/components/molecules/FormInputBox";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";

const schema = yup.object({
  user: yup.object({
    newPassword: yup
      .string()
      .required("비밀번호는 필수 입력입니다.")
      .min(8, "비밀번호는 최소 8자 이상이어야 합니다.")
      .max(20, "비밀번호는 최대 20자 이하이어야 합니다."),
    newPasswordCheck: yup
      .string()
      .oneOf([yup.ref("newPassword")], "비밀번호가 일치하지 않습니다.")
      .required("비밀번호 재확인은 필수 입력입니다."),
  }),
});

export const ChangePwPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = location.state || {};
  const { control, handleSubmit } = useForm({
    resolver: yupResolver(schema),
  });

  const { mutateAsync: changePw } = useMutation({
    mutationFn: (data: { id: string; newPassword: string }) => {
      return request<BaseResponse>({
        method: "PUT",
        url:
          userData.loginType === "student"
            ? "student/change-pw"
            : "guardian/change-pw",
        data: data,
      });
    },
    onSuccess: (res) => {
      navigate("/auth/account/check-password");
    },
  });

  const onSubmit = async (data: any) => {
    try {
      changePw({ id: userData.id, newPassword: data.user.newPassword });
    } catch (error) {
      console.error("Error updating password:", error);
      showAlert(
        "현재 비밀번호를 잘못 입력했습니다.\n입력하신 내용을 다시 확인해주세요."
      );
    }
  };

  return (
    <MainTemplate
      nav={false}
      subPage={true}
      menuBtn={false}
      buttonLeft={
        <Buttons
          type="button"
          size="headerTextIcon"
          layout="text"
          color="bright100"
          icon={<IconArrow />}
          label="뒤로"
          onClick={() => window.history.back()}
        />
      }
    >
      <Form
        title="비밀번호 변경"
        submitBtn={
          <Buttons
            type="submit"
            size="lg"
            color="primary100"
            layout="solid"
            label="비밀번호 변경하기"
            onClick={handleSubmit(onSubmit)}
          />
        }
      >
        <FormInputBox>
          <>
            <Controller
              name="user.newPassword"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextControl
                  {...field}
                  control={control}
                  name="user.newPassword"
                  label="새 비밀번호"
                  placeholder="새 비밀번호를 입력하세요."
                  required={true}
                />
              )}
            />
            <Controller
              name="user.newPasswordCheck"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextControl
                  {...field}
                  control={control}
                  name="user.newPasswordCheck"
                  label="새 비밀번호 확인"
                  placeholder="새 비밀번호를 다시 입력하세요."
                  required={true}
                />
              )}
            />
          </>
        </FormInputBox>
      </Form>
    </MainTemplate>
  );
};
